export const texts = {
  es: {
    redirectTitle: "Estás siendo redirigido...",
    redirectTipBeforeCountdownDone: "Esto puede tardar unos minutos.",
    redirectTipAfterCountdownDone:
      "Si no funciona, podés encontrar el enlace en el correo que te enviamos al mail utilizado para este registro.",
    redundantRedirectLink:
      "Hacé click acá si no fuiste redirigido automáticamente.",
    success: {
      title: "¡Terminaste el registro!",
      subtitle:
        "Procesaremos tu solicitud y nos pondremos en contacto a la brevedad.",
    },
  },
  en: {
    redirectTitle: "You're being redirected...",
    redirectTipBeforeCountdownDone: "This can take a few minutes.",
    redirectTipAfterCountdownDone:
      "If it didn't work, you can still find the link on the email we've sent you during this registration process.",
    redundantRedirectLink:
      "Click here if you weren't automatically redirected.",
    success: {
      title: "You have finished your registration!",
      subtitle: "We will process your request and get in touch shortly.",
    },
  },
};